<div class="container-fluid" *ngIf="clienteserviceParam.rolABFlag">
  <div class="row table-full">
    <div class="table-data">
      <div class="table4">
        <table class="table table-borderless">
          <thead class="thead-light">
            <tr>
              <th colspan="6" scope="col">DATOS GENERALES DEL CLIENTE</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>DPI</th>
              <th>Primer nombre</th>
              <th>Primer Apellido</th>
            </tr>
            <tr>
              <td><input type="text" [(ngModel)]="clientData.cliente.dpi" class="form-control p-0"
                  placeholder="Ingrese telefono" name="bonos"
                  [readOnly]="clientData.cliente.dpi && clientData.cliente.dpi !== ''"></td>
              <td><input type="text" [(ngModel)]="clientData.cliente.primerNombre" class="form-control p-0"
                  placeholder="Primer Nombre" name="bonos"
                  [readOnly]="clientData.cliente.primerNombre && clientData.cliente.primerNombre !== '' && !errorSatFlag">
              </td>
              <td><input type="text" [(ngModel)]="clientData.cliente.primerApellido" class="form-control p-0"
                  placeholder="Primer Apellido" name="bonos"
                  [readOnly]="clientData.cliente.primerApellido && clientData.cliente.primerApellido !== '' && !errorSatFlag">
              </td>
            </tr>
            <tr>
              <th *ngIf='clientData.cliente.existeClienteActivoBanca=="N" && clientData.cliente.tipoClasificacionCliente=="CN"'>Género</th>
              <th *ngIf="datosAvalidar.nit==false">NIT</th>
              <th>Teléfono móvil</th>
            </tr>
            <tr>
              <td *ngIf='clientData.cliente.existeClienteActivoBanca=="N" && clientData.cliente.tipoClasificacionCliente=="CN"'>
                <select
                  class="form-control selecctDatosGenerales" [(ngModel)]="clientData.cliente.genero" name="genero">
                  <option value="M" selected="selected">MASCULINO</option>
                  <option value="F">FEMENINO</option>
                </select>
              </td>
              <td *ngIf='datosAvalidar.nit==false'><input type="text" [(ngModel)]="clientData.cliente.nit"
                  class="form-control p-0" placeholder="Nit" name="bonos"></td>
              <td><input type="text" [(ngModel)]="movilPrincipal" class="form-control p-0" placeholder="Ingrese celular"
                  name="bonos" maxlength="8"></td>
            </tr>
            <tr *ngIf="!clientData.cliente.fechaNacimiento || errorSatFlag || !datosAvalidar.estadoCivil">
              <th *ngIf="!clientData.cliente.fechaNacimiento || errorSatFlag">Fecha de nacimiento</th>
              <th *ngIf="!clientData.cliente.fechaNacimiento || errorSatFlag">Edad</th>
              <th *ngIf='!datosAvalidar.estadoCivil'>Estado Civil</th>
            </tr>
            <tr *ngIf="!clientData.cliente.fechaNacimiento || errorSatFlag || !datosAvalidar.estadoCivil">
              <td *ngIf="!clientData.cliente.fechaNacimiento || errorSatFlag"><input type="text" [textMask]="{mask: mask}" [(ngModel)]="clientData.cliente.fechaNacimiento"
                  class="form-control p-0" placeholder="dd/mm/aaaa" name="bonos" (blur)="getEdadCliente()">
              </td>
              <td *ngIf="!clientData.cliente.fechaNacimiento || errorSatFlag">{{ age }}</td>
              <td *ngIf='!datosAvalidar.estadoCivil'>
                <select class="form-control selecctDatosGenerales" [(ngModel)]="clientData.cliente.estadoCivil"
                  name="estadoCivil">
                  <option *ngFor="let option of estadoCivilOptions" [value]="option.value">{{ option.label }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th *ngIf='!datosAvalidar.tipoVivienda'>Tipo vivienda</th>
              <th>Correo electrónico</th>
            </tr>
            <tr>
              <td *ngIf='!datosAvalidar.tipoVivienda'>
                <select class="form-control selecctDatosGenerales" [(ngModel)]="clientData.cliente.tipoVivienda"
                  name="tipoVivienda">
                  <option *ngFor="let option of tipoViviendaOptions" [value]="option.value">{{ option.label }}</option>
                </select>
              </td>
              <td><input type="text" [(ngModel)]="clientData.cliente.email"
                class="form-control p-0" placeholder="Email" name="Email"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div style="text-align: left;">
        <button class="btn round-button-back" (click)="goBack()">Cancelar</button>
      </div>
    </div>
    <div class="col-md-6">
      <div style="text-align: right;">
        <button class="btn round-button" (click)="goToIngresos()">Continuar</button>
      </div>
    </div>
  </div>
</div>